import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';

const StyledInput = styled.input(({ theme: { base, components } }) => {
  return css`
    width: 100%;
    height: ${components.input.height};
    min-height: ${base['hit-area']['mouse-min']};
    padding: 0 ${components.input.padding};
    appearance: none;
    -webkit-appearance: none;
    text-align: inherit;

    @media (pointer: coarse) {
      min-height: ${base['hit-area']['finger-min']};
    }
  `;
});

StyledInput.defaultProps = defaultThemeProp;

export default StyledInput;
